<template>
  <Modal
    classs="pricing-model-switch-modal"
    hClass="pricing-model-switch-modal__reset-spacing"
    mClass="pricing-model-switch-modal__reset-spacing"
    @cancel="onClose"
  >
    <template #header>
      <div class="pricing-model-switch-modal__header">
        <p class="pricing-model-switch-modal__ttl">{{ $t('pricing.downgradeBilling.title') }}</p>
        <i class="icon icon-cancel pricing-model-switch-modal__close" @click="onClose" />
      </div>
    </template>
    <template #default>
      <div class="pricing-model-switch-modal__body">
        <p>{{ $t('pricing.downgradeBilling.desc1') }}</p>
        <p class="pricing-model-switch-modal__spacing pricing-model-switch-modal__link">&nbsp;</p>
        <ol class="pricing-model-switch-modal__list">
          <li v-html="$t('pricing.downgradeBilling.desc2')"></li>
          <li v-html="$t('pricing.downgradeBilling.desc3')"></li>
          <li
            v-html="$t('pricing.downgradeBilling.desc4', {
              link: `https://forms.clickup.com/3807076/f/3m5v4-41565/MUC1XWMQFMULNI0ZT9?shopify_domain=${shopDomain}&shopify_email=${shopEmail}`
            })"
          ></li>
        </ol>
        <p class="pricing-model-switch-modal__spacing pricing-model-switch-modal__link">&nbsp;</p>
        <p>{{ $t('pricing.downgradeBilling.desc5') }}</p>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import { mutations } from "@/store/downgrade/types";

export default {
  computed: {
    ...mapState("account", {
      shopDomain: state => state.shopInfo.shopifyDomain,
      shopEmail: state => state.shopInfo.shopifyDomain
    }),
  },
  methods: {
    ...mapMutations("downgrade", {
      toggleBlockModal: mutations.TOGGLE_BLOCK_MODAL
    }),
    onClose() {
      this.toggleBlockModal(false);
    }
  }
}
</script>

<style lang="scss">
.pricing-model-switch-modal {
  &__reset-spacing {
    margin: 0 !important;
    padding: 0 !important;
  }
  &__header {
    display: flex;
    width: 600px;
    align-items: center;
    justify-content: space-between;
    border-bottom-width: 1px;
    border-color: rgb(238, 238, 238);
    background-color: rgb(255, 255, 255);
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    line-height: 22px !important;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
  }
  &__ttl {
    font-size: 18px !important;
    line-height: 22px !important;
    font-weight: 500;
    color: rgb(33, 33, 33);
  }
  &__close {
    font-size: 11px;
    cursor: pointer;
    padding: 6.5px;
  }
  &__body {
    width: 600px;
    background-color: rgb(255, 255, 255);
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px !important;
    color: rgb(103, 103, 103);
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  &__list {
    list-style-type: decimal;
    padding-left: 16px;
  }
  &__link {
    font-weight: 600;
    color: rgb(60, 103, 255);
  }
  &__spacing {
    height: 22px;
  }
}
</style>
